import {Injectable} from '@angular/core';
import {BBRestEndpointService} from '../@modules/bb-rest/bb-rest-endpoint.service';
import {Observable} from 'rxjs/Observable';
import {EmploymentStatus} from '../@models/employment-status.model';

@Injectable()
export class EmploymentStateDBService {
  prefix = 'employment-statuses/v2';
  list: Observable<EmploymentStatus.Model[]> = <Observable<EmploymentStatus.Model[]>>
    this.api.getAllRecords(this.prefix).toArray().shareReplay();

  constructor(private api: BBRestEndpointService) {
  }

  get(employmentStatusId: number): Observable<EmploymentStatus.Model> {
    return this.list
      .flatMap(branchList => Observable.of(...branchList))
      .filter(s => s.pk === employmentStatusId)
      .first();
  }
}
